import React, {Component} from 'react';

class InputText extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {value: props.value};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {value} = this.props;
        if (!this.isValueBeingChanged && value !== prevState.value) {
            this.setState({value});
        }
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
        'onChange' in this.props && this.props.onChange(value);
    }

    onBlur(rawValue) {
        const value = rawValue;
        this.setState({value});
        this.isValueBeingChanged = false;
        'onBlur' in this.props && this.props.onBlur(value);
    }

    render() {
        const {
            className = '',
            percent = false,
            min,
            max,
            type = 'text',
            keyboard,
            testId,
            prepend,
            tooltipSubject,
            placeholder = '',
        } = this.props;
        const element = percent ? 'div' : React.Fragment;
        const elementProps = percent ? {className: 'percent-in'} : null;
        const inputNumberProps =
            type === 'number' || keyboard === 'number'
                ? {
                      inputMode: 'decimal',
                  }
                : {};

        return React.createElement(
            element,
            elementProps,
            <>
                {prepend}
                <input
                    type={type}
                    className={`form-control ${className}`}
                    placeholder={placeholder}
                    value={this.state.value}
                    {...inputNumberProps}
                    min={min}
                    max={max}
                    onChange={((e) => this.onChange(e.target.value)).bind(this)}
                    onBlur={((e) => this.onBlur(e.target.value)).bind(this)}
                    {...(testId && {'data-testid': testId})}
                    {...(tooltipSubject && {'data-tooltip-html': tooltipSubject})}
                />
                {percent && <span className="percent">%</span>}
            </>,
        );
    }
}

export default InputText;
